import _isMobile from 'is-mobile';

import { IS_WEBVIEW } from '../components/layout/headerIconsContainer';

export const isMobileApple = (): boolean => {
	if (/iPad|iPhone|iPod/.test(navigator.platform)) {
		return true;
	} else {
		return !!(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
	}
};

export const isForefoxIOS = (): boolean => !!navigator.userAgent.match('FxiOS');

export const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export const isMobile = _isMobile({ tablet: true }) || isMobileApple() || !!IS_WEBVIEW;
